export class TradeMeasureMap {
  constructor(ctryCode, ctryISO3, ctryName, exportColor, exportMeasureCount, importColor, importMeasureCount) {
    this.ctryCode = ctryCode;
    this.ctryISO3 = ctryISO3;
    this.ctryName = ctryName;
    this.exportColor = exportColor;
    this.exportMeasureCount = exportMeasureCount;
    this.importColor = importColor;
    this.importMeasureCount = importMeasureCount;
  }
  static fromApiObject(input) {
    if (input && typeof(input) === "object") {
      return new TradeMeasureMap(input.CtryCode, input.CtryISO3, input.CtryName, input.ExportColor, input.ExportMeasureCount, input.ImportColor, input.ImportMeasureCount)
    }
    return new TradeMeasureMap();
  }
  static fromApiArray(input) {
    if (Array.isArray(input)) {
      return input.map(item => TradeMeasureMap.fromApiObject(item));
    }
    if (typeof(input) === "object") {
      return [TradeMeasureMap.fromApiObject(input)];
    }
    return [];
  }
}